import React from "react";
import { Fade } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

export const FadeTransition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) => {
    return <Fade ref={ref} {...props} />;
  },
);
